import { Flex } from '@chakra-ui/react'

import { CtkLoader } from '@/components/icons/ctk-logo'

export const LoadingView = (): JSX.Element => (
  <Flex align="center" justify="center" h="full">
    <Flex className="w-16 h-16">
      <CtkLoader />
    </Flex>
  </Flex>
) 